var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUpDown = function SvgUpDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#002F6E",
    d: "m6 17.496 4.057-4.039a.73.73 0 0 1 .522-.227q.3-.006.532.227a.74.74 0 0 1 .233.535q0 .302-.233.535l-4.033 4.048q-.44.44-1.079.44-.638 0-1.078-.44L.873 14.527a.71.71 0 0 1-.22-.53.75.75 0 0 1 .235-.54.72.72 0 0 1 .535-.227q.3.005.534.227zM6 2.504 1.956 6.527a.7.7 0 0 1-.522.22.77.77 0 0 1-.532-.22.76.76 0 0 1-.24-.535.7.7 0 0 1 .225-.535l4.033-4.032q.44-.44 1.078-.44t1.08.44l4.032 4.032a.71.71 0 0 1 .22.53.75.75 0 0 1-.235.54.76.76 0 0 1-.527.22.73.73 0 0 1-.527-.22z"
  })));
};
export default SvgUpDown;